<template>
  <div class="page">
    <div class="container">
      <div class="column">
        <div class="content">
          <div style="text-align:center">
            <h3>Cadastro</h3>
          
          <i> Caso você já tenha feito seu cadastro, pedimos que realize o <el-button type="text" @click="$router.push('/p/login')">login</el-button></i>
          </div>
          
          <el-form ref="form" :model="form" label-width="200px">
            <el-form-item label="CPF">
             <the-mask :mask="'###.###.###-##'" class="input" name="cpf" v-model='model.cpf' placeholder="seu CPF"/>
             <div class="tag is-warning" v-if='checkCPF==2'>CPF já existe em nosso banco de dados, faça o <el-button type="text" @click="$router.push('/p/login')">login</el-button></div>
             <div class="tag is-danger" v-if='checkCPF==0'>CPF Inválido</div>
             <div class="tag is-warning" v-if='model.cpf.length <= 1'>Esse campo é necessário</div>
            </el-form-item>
            <el-form-item label="Nome Completo">
               <el-input v-model="model.nome" placeholder="Nome Completo"></el-input>
               <div class="tag is-warning" v-if='model.nome.length <= 1'>Esse campo é necessário</div>
            </el-form-item>
            <el-form-item label="E-mail">
               <el-input v-model="model.email" placeholder="E-mail"></el-input>
                <div class="tag is-warning" v-if='checkEmail==2'>Email já existe em nosso banco de dados, faça o <el-button type="text" @click="$router.push('/p/login')">login</el-button></div>
             <div class="tag is-danger" v-if='checkEmail==0'>Email Inválido</div>
             <div class="tag is-warning" v-if='model.email.length <= 1'>Esse campo é necessário</div>
            </el-form-item>
            <el-form-item label="Data de Nascimento">
              <el-date-picker
                v-model="model.data_nascimento"
                type="date"
                placeholder="Selecione a Data"
                format='dd/MM/yyyy'
                value-format='yyyy-MM-dd'>
              </el-date-picker><br />
              <div class="tag is-warning" v-if='model.data_nascimento.length <= 1'>Esse campo é necessário</div>
            </el-form-item>
            <el-form-item label="Telefone">
              <the-mask :mask="'+55 (##) #####.####'" class="input" name="telefone" v-model='model.telefone' placeholder="seu Telefone"/>
              <div class="tag is-warning" v-if='model.telefone.length <= 1'>Esse campo é necessário</div>
            </el-form-item>
             <el-form-item label="RG">
               <el-input v-model="model.rg" placeholder="seu RG"></el-input>
               <div class="tag is-warning" v-if='model.rg.length <= 1'>Esse campo é necessário</div>
            </el-form-item>
            <el-form-item label="CEP">
               <el-input v-model="model.cep" placeholder="seu CEP"></el-input>
               <div class="tag is-warning" v-if='model.cep.length <= 1'>Esse campo é necessário</div>
            </el-form-item>
             <el-form-item label="Endereço">
               <el-input v-model="model.endereco" placeholder=" seu Endereço"></el-input>
               <div class="tag is-warning" v-if='model.endereco.length <= 1'>Esse campo é necessário</div>
            </el-form-item>
             <el-form-item label="Cidade">
               <el-input v-model="model.cidade" placeholder=" sua cidade "></el-input>
               <div class="tag is-warning" v-if='model.cidade.length <= 1'>Esse campo é necessário</div>
            </el-form-item>
             <el-form-item label="Estado">
               <select v-model="model.estado" class="input" name="estado" ><option selected="selected" disabled value=''>Selecione o Estado</option><option value="Acre">Acre</option><option value="Alagoas">Alagoas</option><option value="Amapá">Amapá</option><option value="Amazonas">Amazonas</option><option value="Bahia">Bahia</option><option value="Ceará">Ceará</option><option value="Distrito Federal">Distrito Federal</option><option value="Espírito Santo">Espírito Santo</option><option value="Goiás">Goiás</option><option value="Maranhão">Maranhão</option><option value="Mato Grosso">Mato Grosso</option><option value="Mato Grosso do Sul">Mato Grosso do Sul</option><option value="Minas Gerais">Minas Gerais</option><option value="Pará">Pará</option><option value="Paraíba">Paraíba</option><option value="Paraná">Paraná</option><option value="Pernambuco">Pernambuco</option><option value="Piauí">Piauí</option><option value="Rio de Janeiro">Rio de Janeiro</option><option value="Rio Grande do Sul">Rio Grande do Sul</option><option value="Rio Grande do Norte">Rio Grande do Norte</option><option value="Rondônia">Rondônia</option><option value="Roraima">Roraima</option><option value="Santa Catarina">Santa Catarina</option><option value="São Paulo">São Paulo</option><option value="Sergipe">Sergipe</option><option value="Tocantins">Tocantins</option><option value="Outro">Outro</option></select>
               <div class="tag is-warning" v-if='model.estado.length <= 1'>Esse campo é necessário</div>
            </el-form-item>
            <el-form-item label="Profissão">
               <select v-model="model.profissao" class="input" name="profissao">
                <option selected="selected" value='' disabled>Selecione a Profissão</option>
                <option v-for='i in profissoes' v-bind:key='i.id' :value='i.profissao' >{{i.profissao}}</option>
               </select>
               <div class="tag is-warning" v-if='model.profissao.length <= 1'>Esse campo é necessário</div>
            </el-form-item>
            <el-form-item label="Semestre" v-if='model.profissao == "Estudante" '>
             <el-input type="number" v-model="model.semestre" placeholder="semestre"></el-input>
            </el-form-item>
            <hr />
            <el-form-item label="Senha">
             <el-input type="password" v-model="model.senha" placeholder="senha"></el-input>
            </el-form-item>
            <el-form-item label="Confirmar Senha">
             <el-input type="password" v-model="model.repetirSenha" placeholder="repetir senha"></el-input>
             <div class="tag is-warning" v-if='checkPassword==0'>A senhas devem ser iguais e maiores que 5 caracteres.</el-button></div>
            </el-form-item>
            
            <el-form-item>
              <el-button type="primary" @click="submitForm" >Realizar Cadastro</el-button>
            </el-form-item>
          </el-form>
          </vue-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment'
import VueForm from 'vue-form';
import Vue from 'vue';
import {TheMask} from 'vue-the-mask'
import is from 'is_js'
import resource from '@/resource';



Vue.use(VueForm);

export default {
  name: 'QuemSomos',
  components:{
    TheMask
  },
  data(){
    return {
      curso: null,
      loading: false,
      formstate: {},
      profissoes: [],
      model: {
        cpf: '',
        telefone: '',
        nome: '',
        email: '',
        semestre: '',
        rg: '',
        endereco: '',
        cidade: '',
        estado: '',
        cep: '',
        profissao: '',
        senha: '',
        repetirSenha: '',
        data_nascimento: '',

      },
      form: {}
    }
  },
  asyncComputed:{
    checkCPF(){
      const cpf = this.model.cpf;
      return new Promise((resolve, reject) => {
        if(cpf.length == 11 ){
          if(this.validarCPF(cpf)){
              resource.get({
                url: "/session/cpf/", 
                msg: 'Verificando seu CPF',
                params: {
                  cpf: cpf
                }
              },res => { 
                if(res.status==2){
                  resolve("2")
                }else{
                  resolve("1")
                }
              }, error => {
                resolve("0")
              });
          }else{
            resolve("0")
          }
        }else{
          resolve(null)
        }
      })
    },
    checkEmail(){
      const email = this.model.email;
      return new Promise((resolve, reject) => {
        if(email){
          if(is.email(email)){
              resource.get({
                url: "/session/email/", 
                msg: 'Verificando seu E-mail', 
                silent: true,
                params: {
                  email: email
                }
              },res => { 
                if(res.status==2){
                  resolve("2")
                }else{
                  resolve("1")
                }
              }, error => {
                resolve("0")
              });
          }else{
            resolve("0")
          }
        }else{
          resolve(null)
        }
      })
    }
  },
  computed:{
    checkPassword(){
      if(this.model.senha == '' && this.model.repetirSenha == ''){
        return null
      }else if(this.model.senha == this.model.repetirSenha && this.model.senha.length > 5){
        return "1"
      }else{
        return "0"
      }
    }
  },
  methods:{
    submitForm(){
      if(  this.checkCPF == "1" 
        && this.checkEmail == "1" 
        && this.checkPassword == "1"
        && this.model.nome.length > 1
        && this.model.telefone.length > 1
        && this.model.data_nascimento.length > 1
        && this.model.rg.length > 1
        && this.model.endereco.length > 1
        && this.model.cep.length >1
        && this.model.estado.length > 1
        && this.model.cidade.length > 1
        && this.model.profissao.length > 1)
      {
        const data = {
          nome: this.model.nome,
          rg: this.model.rg,
          cpf: this.model.cpf,
          nascimento: this.model.data_nascimento,
          email: this.model.email,
          telefone: this.model.telefone,
          semestre: this.model.semestre,
          endereco: this.model.endereco,
          cep: this.model.cep,
          estado: this.model.estado,
          cidade: this.model.cidade,
          profissao: this.model.profissao,
          senha: this.model.senha
        };
        resource.post({
          url: "/session/register/", 
          msg: 'Realizando seu cadastro.',
          data: data
        },res => { 
          this.$alert('Seu cadastro foi realizado com sucesso. Em breve você receberá um email para ativar a sua conta. Caso esse e-mail não apareça em sua caixa de entrada, envie-nos um contato. ', 'Cadastro Realizado com sucesso!', {
          confirmButtonText: 'Certo',
          callback: action => {
            this.$router.push("/")
          }
         })
        }, error => {
          this.$alert('Não foi possível realizarmos o seu cadastro. Pedimos que entre em contato conosco pelo formulário de contato ou através do email suporte@espacowinnicottbsb.com.br', 'Seu cadastro não foi realizado!', {
          confirmButtonText: 'Certo',
          callback: action => {
            
          }
         })
        });
      }else{
        this.$alert('Você não preencheu as informações corretamente.', 'Verifique suas informações!', {
          confirmButtonText: 'Certo',
          callback: action => {
            
          }
         })
      }
    },
    validarCPF(cpf) { 
      cpf = cpf.replace(/[^\d]+/g,'');  
      if(cpf == '') return false; 
      // Elimina CPFs invalidos conhecidos  
      if (cpf.length != 11 || 
        cpf == "00000000000" || 
        cpf == "11111111111" || 
        cpf == "22222222222" || 
        cpf == "33333333333" || 
        cpf == "44444444444" || 
        cpf == "55555555555" || 
        cpf == "66666666666" || 
        cpf == "77777777777" || 
        cpf == "88888888888" || 
        cpf == "99999999999")
          return false;   
      // Valida 1o digito 
      let add = 0;  
      for (let i=0; i < 9; i ++)    
        add += parseInt(cpf.charAt(i)) * (10 - i);  
        let rev = 11 - (add % 11);  
        if (rev == 10 || rev == 11)   
          rev = 0;  
        if (rev != parseInt(cpf.charAt(9)))   
          return false;   
      // Valida 2o digito 
      add = 0;  
      for (let i = 0; i < 10; i ++)   
        add += parseInt(cpf.charAt(i)) * (11 - i);  
      rev = 11 - (add % 11);  
      if (rev == 10 || rev == 11) 
        rev = 0;  
      if (rev != parseInt(cpf.charAt(10)))
        return false;   
      return true;   
    },
    handleClick() {
        console.log('click');
    },
    getProfissoes(){
      resource.get({
        url: "/info/profissoes/", 
        msg: "Carregando algumas informações",
        params: {
        }
      },res => { 
        this.profissoes = res;
      }, error => {
        this.$alert('Erro ao acessar o servidor. Se essa mensagem persistir contate o suporte@espacowinnicottbsb.com.br .', 'Erro ao acessar o servidor!', {
          confirmButtonText: 'Certo',
          callback: action => {
            
          }
         })
      });
    },
    formatInscricao(f){
      return moment(f, "%Y-%MM-%DD").format("DD [de] MMMM [de] YYYY");
    }
  },
  mounted(){
    this.getProfissoes();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page{
    text-align: left
  }
  .container{
    max-width: 800px;
  }
  .error-msg{
    font-size:12px;
    color:#D44949;
  }
</style>
